module.exports = __webpack_public_path__ + "img/Desktop - 11.ab43098c.svg";